export default {
  name: 'titlewrap',
  props: {
    txt: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};